import { AlmdedalenIcon } from "@/components/almedalen-icon";
import { Link } from "react-router-dom";

function LoginHeader() {
  return (
    <header className="w-full bg-gray border-b border-input flex items-center justify-between">
      <div className="max-w-[1440px] mx-auto gap-x-2 flex items-center lg:items-end justify-between w-full lg:px-6 lg:py-0 ">
        <Link to="/">
          <AlmdedalenIcon className="w-fit min-w-[107px] h-[120px] hidden lg:block" />
          <AlmdedalenIcon className="w-12 h-full lg:hidden block" />
        </Link>
      </div>
    </header>
  );
}

export default LoginHeader;